module.exports = __webpack_public_path__ + "static/10-ce18f97bdf119b1076abdaeac77951f3.jpg";